<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showSupervisor") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <div class="badges_wrapper justify-content-between">
        <div class="wrapper"></div>
        <v-chip :color="data.active ? 'green' : 'red'" text-color="white">
          {{ data.active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>

      <form>
        <div class="row">
          <div
            class="preview-container text-center my-3"
            v-if="data.image.path"
          >
            <img
              :src="data.image.path"
              :alt="$t('PLACEHOLDERS.personalImage')"
            />
          </div>

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.name')"
            v-model.trim="data.name"
            disabled
          />

          <base-input
            col="6"
            type="email"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />

          <base-input
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.mobileNumber')"
            v-model.trim="data.mobile"
            disabled
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.city')"
            v-model.trim="data.city"
            disabled
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('TABLES.Workplaces.date')"
            v-model.trim="data.created_at"
            disabled
          />

          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
              disabled
            ></v-switch>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShowSupervisor",

  data() {
    return {
      data: {
        image: {
          path: null,
        },
        name: null,
        email: null,
        mobile: null,
        city: null,
        created_at: null,
        active: false,
      },
    };
  },

  methods: {
    async showSupervisor() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `supervisors/${this.$route.params.id}`,
        });
        const item =
          res.data.data?.supervisor ||
          res.data.data?.user ||
          res.data.data?.rep ||
          res.data.data;

        this.data.image.path = item?.avatar;
        this.data.name = item?.name;
        this.data.email = item?.email;
        this.data.mobile = item?.mobile;
        this.data.city =
          item?.city?.name || item?.city?.name_ar || item?.city?.name_en;
        this.data.created_at = item?.created_at;
        this.data.active = !!item?.is_active;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
  },

  created() {
    this.showSupervisor();
  },
};
</script>

<style scoped>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
}
</style>
